var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { StyledFlag, BorderFlag, StyledFlagContainer } from "./ColorFlag.style";
import useUniqueId from "../../hooks/useUniqueId";
import { useNxTranslation } from "../../i18n/useNxTranslation";
import translationEN from "./locales/translation-en.json";
import translationFR from "./locales/translation-fr.json";
const prefixId = "nx-flag-";
export const ColorFlagVariant = ["none", "red", "yellow", "green", "blue", "purple", "violet", "gray"];
const ColorFlag = (_a) => {
    var { id, "data-insights": insightsAttr, color = "none", disabled = false } = _a, rest = __rest(_a, ["id", "data-insights", "color", "disabled"]);
    id = useUniqueId(prefixId, id);
    const { t, nxI18n } = useNxTranslation();
    nxI18n.addResources("en", "interactiveTags", translationEN);
    nxI18n.addResources("fr", "interactiveTags", translationFR);
    const title = color ? color : "none";
    const FLAG_HEIGHT = "10px";
    const FLAG_WIDTH = "14px";
    return (React.createElement(StyledFlagContainer, { title: t(title, { ns: "interactiveTags" }), "aria-hidden": "true" }, color !== "none" ? (React.createElement(StyledFlag, Object.assign({ "data-insights": insightsAttr, width: FLAG_WIDTH, height: FLAG_HEIGHT, color: color, id: id, disabled: disabled }, rest))) : (React.createElement(BorderFlag, Object.assign({ "data-insights": insightsAttr, width: FLAG_WIDTH, height: FLAG_HEIGHT, id: id, disabled: disabled }, rest)))));
};
export default ColorFlag;
//# sourceMappingURL=ColorFlag.js.map